import { useEffect, useState } from "react";
import {
	webinarCardStatusLabel,
	webinarHeroStatusKind,
} from "./webinarHeroStatus";

export function useWebinarCardStatusLabel(startDatetime, jStartDatetime = "") {
	const [label, setLabel] = useState(() =>
		webinarCardStatusLabel(startDatetime, jStartDatetime),
	);

	useEffect(() => {
		const sync = () =>
			setLabel(webinarCardStatusLabel(startDatetime, jStartDatetime));
		sync();
		const kind = webinarHeroStatusKind(startDatetime);
		if (kind === "none") {
			return undefined;
		}
		const intervalMs = kind === "countdown" ? 60_000 : 30_000;
		const interval = setInterval(sync, intervalMs);
		return () => clearInterval(interval);
	}, [startDatetime, jStartDatetime]);

	return label;
}
